// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__wiRjZ","errorLogs":"styles_errorLogs__3IYnc"};